import React from "react";
import { NavLink } from "react-router-dom";

const Navigation = () => {
  return (
    <nav>
      <div className='container'>
        <div className='nav-columns'>
          <div className='nav-column'>
            <div className='nav-label'>Menu</div>
            <ul className='nav-links'>
              <li>
                <NavLink to='/case-studies' exact>
                  Program
                </NavLink>
              </li>
              {/* <li>
                <NavLink to='/approach' exact>
                  Our Students
                </NavLink>
              </li> */}
              <li>
                <NavLink to='/services' exact>
                  About Us
                </NavLink>
              </li>
              <li>
                <NavLink to='/about-us' exact>
                  Our Students
                </NavLink>
              </li>
            </ul>
          </div>
          <div className='nav-column'>
            <div className='nav-label'>Contact</div>
            <div className='nav-infos'>
              <ul className='nav-info'>
                <li className='nav-info-label'>Email</li>
                <li>
                  <NavLink to='/contact' exact>
                    enroll@one-2-cloud.com
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink to='/audit' exact>
                    Get a free audit
                  </NavLink>
                </li> */}
              </ul>
              <ul className='nav-info'>
                <li className='nav-info-label'>Headquarter</li>
                <li>somewhere in the clouds</li>
              </ul>
              {/* <ul className='nav-info'>
                <li className='nav-info-label'>Phone</li>
                <li>+41 (0) 79 510 28 70</li>
              </ul> */}
              {/* <ul className='nav-info'>
                <li className='nav-info-label'>Legal</li>
                <li>Privacy & Cookies</li>
              </ul> */}
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
